import { useTranslation } from '@framework/i18n';
// eslint-disable-next-line no-restricted-imports
import { Prompt, useHistory } from 'react-router';

interface PreventNavigationProps {
  when: boolean;
  message?: string;
  /**
   * Elenco di pattern di pathname per cui la navigazione è sempre consentita
   * senza mostrare l'avviso di "modifiche non salvate".
   *
   * Quando l'utente prova a lasciare il form, se il pathname dell'URL di
   * destinazione corrisponde ad almeno una di queste espressioni regolari,
   * la navigazione prosegue senza attivare il prompt di conferma.
   *
   * N.B.: il match viene effettuato solo sul `location.pathname`, non su
   * query string (`search`) o hash (`hash`).
   */
  allowedUrls?: RegExp[];
}

/**
 * Notifica l'utente che sta lasciando una pagina quando `when` è vera.
 * Utile per evitare di lasciare form non salvati.
 * NB: se utilizzato con RHF, usare FormPreventNavigation
 *
 * @see FormPreventNavigation
 */
export function PreventNavigation(props: PreventNavigationProps) {
  const { allowedUrls } = props;
  const history = useHistory();
  const { t } = useTranslation();

  // Disabilitato in caso non ci sia una location, es. storybook
  if (!history) return null;

  const currentLocation = history.location;

  return (
    <Prompt
      when={props.when}
      message={(location, action) => {
        // Abilitamo la navigazione agli anchor (#)
        if (location.pathname === currentLocation.pathname) {
          return true;
        }

        // Controlliamo se l'url di destinazione è tra quelli permessi
        if (allowedUrls?.length) {
          const destinationUrl = location.pathname;
          if (allowedUrls.some(regex => regex.test(destinationUrl))) {
            return true;
          }
        }

        return (
          props.message ??
          t(
            'form.prevent-navigation.prompt',
            'Sei sicuro di voler abbandonare la pagina? Tutte le modifiche non salvate andranno perse',
          )
        );
      }}
    />
  );
}
